@if (error) {
  <p
    [tp]="error"
    tpPlacement="right"
    [tpOnlyTextOverflow]="true"
    class="absolute ml-1 text-[11px] mt-px text-red-600 truncate w-full"
    >
    {{ error }}
  </p>
}
